import { render, staticRenderFns } from "./Header3.vue?vue&type=template&id=41bc58ec&scoped=true&"
import script from "./Header3.vue?vue&type=script&lang=ts&"
export * from "./Header3.vue?vue&type=script&lang=ts&"
import style0 from "./Header3.vue?vue&type=style&index=0&id=41bc58ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41bc58ec",
  null
  
)

export default component.exports